var Parsley = {
    init: function () {
        $('.c-input').on('focusout', function(){
            if(!$.trim(this.value).length){
                $(this).removeClass('has-error');
            }
          });
        $('#js-form-login').parsley({
            trigger: 'change',
            successClass: "has-success",
            errorClass: "has-error",
            // classHandler: function (el) {
            //     return el.$element.closest('.c-form-group');
            // },
            errorsWrapper: '',
            errorTemplate: '',
        });

        $('#js-form-register').parsley({
            trigger: 'change',
            successClass: "has-success",
            errorClass: "has-error",
            // classHandler: function (el) {
            //     return el.$element.closest('.c-form-group');
            // },
            errorsWrapper: '',
            errorTemplate: '',
        });
        //konto-page muj-profil
        $('#js-form-personal').parsley({
            trigger: 'change',
            successClass: "has-success",
            errorClass: "has-error",
            errorsWrapper: '',
            errorTemplate: '',
        });
        //konto-page muj-profil
        $('#js-form-pswchange').parsley({
            trigger: 'change',
            successClass: "has-success",
            errorClass: "has-error",
            errorsWrapper: '',
            errorTemplate: '',
        });
        //konto-page moje-predplatne
        $('#js-form-giftcode').parsley({
            trigger: 'change',
            successClass: "has-success",
            errorClass: "has-error",
            errorsWrapper: '',
            errorTemplate: '',
        });
    }
}

module.exports = Parsley;